export interface IBaseError {
  name: string;
  message: string;
  stack?: string;
}

export abstract class BaseError extends Error implements IBaseError {
  name: string = "BaseError";

  constructor(message: string = "") {
    super(message);
    this.message = message;

    const errorConstructor = Error as any;
    if (errorConstructor.captureStackTrace) {
      errorConstructor.captureStackTrace(this, this.constructor);
    }
  }

  handleError() {
    console.error(this.message, this);
  }

  toIBaseError() {
    const iBaseError: IBaseError = {
      name: this.name,
      message: this.message,
      stack: this.stack,
    };
    return iBaseError;
  }
}
